import React, { useState, useEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';

import { connect } from "react-redux";
import { compose } from "redux";
import Collapse from '../assets/images/collapse.svg';
import Expand from '../assets/images/uncollapse.svg';
//import AddUp from '../assets/images/addup.svg';
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LuArrowLeft } from "react-icons/lu";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { LuPlus, LuBuilding2, LuToggleLeft, LuToggleRight, LuFolderPlus, LuChevronDown, LuChevronRight, LuPencil, LuUserPlus, LuSettings } from "react-icons/lu";
import { FiToggleLeft, FiToggleRight } from "react-icons/fi";
import { setSidebarCollapsed } from "../store/actions/authActions";
import { LuPanelRight } from "react-icons/lu";
import { deleteCompany, deleteDepartment, updateCompany, updateDepartment, createDepartment, resetNewlycreatedDepartmentId, getDepartments, getCompanies, createCompany, resetNewlycreatedCompanyId } from "../store/actions/departmentActions";
import { getComplianceStandardsByCompany, deleteComplianceStandard } from "../store/actions/complianceActions";
import Overlay from "../components/Departments/Overlay";
import CompanyOverlay from "../components/Departments/CompanyOverlay";
import NotificationsOverlay from "../components/Departments/NotificationsOverlay";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import ComplianceOverlay from "../components/Compliance/Overlay";
import { addUserDepartment, addUserCompany } from "../store/actions/adminActions"


function Avatar({ name, src, size = 28 }) {
    const [errored, setErrored] = React.useState(false);

    const initials = (name || "")
        .split(" ")
        .map((s) => s[0])
        .filter(Boolean)
        .slice(0, 2)
        .join("")
        .toUpperCase();

    if (!src || errored) {
        return (
            <div
                className="flex items-center justify-center rounded-full border border-gray-300 bg-gray-100 text-gray-500"
                style={{ width: size, height: size }}
                title={name}
            >
                <svg
                    width={Math.floor(size * 0.6)}
                    height={Math.floor(size * 0.6)}
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                >
                    <path d="M10 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 1c-3.33 0-6 1.34-6 3v2h12v-2c0-1.66-2.67-3-6-3Z" />
                </svg>
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={name}
            title={name}
            loading="lazy"
            referrerPolicy="no-referrer"
            className="rounded-full object-cover border border-gray-300 bg-white"
            style={{ width: size, height: size }}
            onError={() => setErrored(true)}
        />
    );
}


const UnitsSideBar = (props) => {




    const { addUserDepartmentFN, addUserCompanyFN, addRiskCenterMemberFN, users, deleteCompanyFN, deleteStandartFN, deleteDepartmentFN, activeCompliance, setActiveCompliance, complianceStandards, getComplianceStandardsByCompanyFN, updateDepartmentFN, updateCompanyFN, sidebar_collapsed, setSidebarCollapsedFN, departments, companies, setActiveDepartment, activeDepartmentId, newlycreatedDepartmentId, resetNewlycreatedDepartmentIdFN, resetNewlycreatedCompanyIdFN, newlyCreatedCompanyId, createDepartmentFN, createCompanyFN, getDepartmentsFN, getCompaniesFN, profile } = props;
    const { t } = useTranslation();
    const [collapsed, setCollapsed] = useState(true);

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isCompanyPopupOpen, setIsCompanyPopupOpen] = useState(false);
    const [isNotificationsPopupOpen, setIsNotificationsPopupOpen] = useState(false);
    const [currentDepartment, setCurrentDepartment] = useState(null);
    const [currentCompany, setCurrentCompany] = useState(null);

    const [showCreateMenu, setShowCreateMenu] = useState(false);

    const [departmentfornotifications, setDepartmentfornotifications] = useState(null);
    const [companyMenuOpenId, setCompanyMenuOpenId] = useState(null);
    const [compMenuOpenId, setCompMenuOpenId] = useState(null);
    const [hoveredComplianceId, setHoveredComplianceId] = useState(null);
    const [editCompliance, setEditCompliance] = useState(0);
    const [isCompPopupOpen, setIsCompPopupOpen] = useState(false);

    const [expandedCompanies, setExpandedCompanies] = useState({}); // { [company_id]: true/false }
    const [memberDepartmentId, setMemberDepartmentId] = useState(null);
    const [deptMenuOpenId, setDeptMenuOpenId] = useState(null);
    const [memberSuccess, setMemberSuccess] = useState("");
    const [createMenuPos, setCreateMenuPos] = useState({ top: 0, left: 0 });
    const [deptMenuPos, setDeptMenuPos] = useState({ top: 0, left: 0 });
    const [compMenuPos, setCompMenuPos] = useState({ top: 0, left: 0 });
    const [companyMenuPos, setCompanyMenuPos] = useState({ top: 0, left: 0 });
    const history = useHistory();

    useEffect(() => {
        const onClick = (e) => {
            // close any open menu when clicking outside
            setDeptMenuOpenId(null);
        };
        document.addEventListener("click", onClick);
        return () => document.removeEventListener("click", onClick);
    }, []);


    const toggleCompany = (company_id) => {
        const key = String(company_id);
        setExpandedCompanies((prev) => ({
            ...prev,
            [key]: !prev?.[key],
        }));
    };

    const isCompanyExpanded = (company_id) => {
        const key = String(company_id);
        return !!expandedCompanies?.[key];
    };

    // const isCompanyExpanded = (company_id) => {
    //     // default = expanded
    //     if (expandedCompanies[company_id] === undefined) return true;
    //     return !!expandedCompanies[company_id];
    // };



    const closeNotificationsPopup = () => {
        setIsNotificationsPopupOpen(false);
    }

    const closeCreation = async (id, data) => {
        if (id)
            await updateDepartmentFN(id, data)
        await getDepartmentsFN();
        ////console.log("New Sidebar Data Trying to get")
        await getComplianceStandardsByCompanyFN();
        ////console.log("New Sidebar Data Gotten")
        resetNewlycreatedDepartmentIdFN();
        setIsPopupOpen(false);

    }

    const closeAllMenus = () => {
        setCompanyMenuOpenId(null);
        setDeptMenuOpenId(null);
        setCompMenuOpenId(null);
    };


    const closeCompliance = () => {
        getComplianceStandardsByCompanyFN();
        setEditCompliance(0);
        setIsCompPopupOpen(false);
    };

    const handleDeleteCompany = async (id) => {
        setCompanyMenuOpenId(null);
        await deleteCompanyFN(id);
        await getCompaniesFN()
    };

    const handleManageRiskCenter = async (id) => {

        history.push("/manage_risk_center/" + id)
    }

    const handleManageSubRiskCenter = async (id) => {
        history.push("/manage_sub_risk_center/" + id);
    };

    const closeCreationCompnay = async (id, data) => {
        //console.log("Data ", data)
        if (id)
            await updateCompanyFN(id, data)
        getCompaniesFN()
        resetNewlycreatedCompanyIdFN();
        setIsCompanyPopupOpen(false);
        ////console.log("Close company ", data, id)
    }

    const closeCreationCompnayNoSave = async () => {

        resetNewlycreatedCompanyIdFN();
        setIsCompanyPopupOpen(false);
        ////console.log("Close company ", data, id)
    }


    useEffect(() => {
        setCollapsed(sidebar_collapsed);
    }, [sidebar_collapsed]);

    useEffect(() => {
        getComplianceStandardsByCompanyFN();
        // Mount-only: listing dispatch props in deps loops when connect remaps after ownProps churn.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (newlycreatedDepartmentId) {
            ////////console.log("newlycreatedDepartmentId", newlycreatedDepartmentId);
            let department = departments && departments.find(department => department.department_id === newlycreatedDepartmentId);
            ////console.log("department", department);
            resetNewlycreatedDepartmentIdFN();
            setCurrentDepartment(department);
            setIsPopupOpen(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newlycreatedDepartmentId]);

    useEffect(() => {
        ////console.log("newlyCreatedCompanyId ", newlyCreatedCompanyId)
        if (newlyCreatedCompanyId) {
            ////////console.log("newlycreatedDepartmentId", newlycreatedDepartmentId);
            ////console.log("Inside")
            let company = companies && companies.find(company => company.company_id === newlyCreatedCompanyId);
            ////////console.log("department", department);
            ////console.log("Company ", company)
            setCurrentCompany(company);
            setIsCompanyPopupOpen(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newlyCreatedCompanyId]);

    useEffect(() => {
        const handleClickOutside = () => {
            setCompanyMenuOpenId(null);
        };

        if (companyMenuOpenId !== null) {
            document.addEventListener("click", handleClickOutside);
        }

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [companyMenuOpenId]);

    /*
    
      <button
                                title={department.name}
                                onClick={() => setActiveDepartment(department.department_id)}
                                className={`flex items-center justify-center w-10 h-10 mb-4 rounded-full hover:bg-[#3b3b3b] hover:bg-opacity-20  ${activeDepartmentId === department.department_id ? 'border-2 border-[#26eb81]' : ''}`}
                                style={{ backgroundColor: department.color }}
                            >
                                <span className="text-white font-bold">{department.name.charAt(0).toUpperCase()}</span>
                            </button>
    
                            */

    const [hoveredDepartmentId, setHoveredDepartmentId] = useState(null);

    const [memberCompanyId, setMemberCompanyId] = useState(null);
    const [memberSearch, setMemberSearch] = useState("");

    const filteredMemberUsers = useMemo(() => {
        const q = memberSearch.toLowerCase().trim();

        return (users || []).filter((user) => {
            const name = `${user.first_name || ""} ${user.last_name || ""}`.toLowerCase();
            const email = (user.email || "").toLowerCase();

            return name.includes(q) || email.includes(q);
        });
    }, [users, memberSearch]);

    return (
        <div
            className={`static ${collapsed ? 'w-0 min-w-0' : 'w-[218px] min-w-[218px]'
                } h-full overflow-y-auto scrollbar-hidden transition-width duration-300 p-0 bg-[#F4F4F4]`}
        >

            <div className="flex flex-col w-full items-center"> {/* Added items-center to center the buttons */}
                {/* {collapsed && <div className={`flex justify-end ${!collapsed ? 'absolute' : ''}`}>
                    <div className={`${collapsed ? 'relative right-0 top-[100px]' : ''}`}>
                        <button onClick={() => setSidebarCollapsedFN(!collapsed)} className={collapsed ? "p-3" : "p-2"}>
                            <img src={collapsed ? Expand : Collapse} alt="Toggle" className="w-7 h-7 hover:opacity-70" />
                        </button>
                    </div>
                </div>} */}


                {!collapsed && (
                    <div className="flex items-center w-full h-16 border-b border-gray-300 relative">
                        <p className="text-[#3b3b3b] font-bold text-sm flex-grow ml-4">
                            {t("sidebar.riskCenters")}
                        </p>

                        <div className="flex items-center relative">
                            {profile && profile.role === "Admin" && (
                                <div className="relative">
                                    {/* Plus button */}
                                    <button
                                        onClick={(e) => {
                                            const r = e.currentTarget.getBoundingClientRect();
                                            setCreateMenuPos({ top: r.bottom + 4, left: r.right - 208 });
                                            setShowCreateMenu(v => !v);
                                        }}
                                        className="ml-4 p-0"
                                        title="Create"
                                    >
                                        <LuPlus className="w-4 h-4 hover:text-[#3b3b3b]" />
                                    </button>

                                    {/* Dropdown */}
                                    {showCreateMenu && createPortal(
                                        <div className="fixed w-52 bg-white border border-gray-200 rounded-xl shadow-xl z-[99999] overflow-hidden py-1" style={{ top: createMenuPos.top, left: createMenuPos.left }}>
                                            <div className="px-3 pt-2.5 pb-1.5 text-[10px] font-semibold text-gray-400 uppercase tracking-wider">
                                                Create new
                                            </div>

                                            <button
                                                onClick={() => {
                                                    setShowCreateMenu(false);
                                                    createCompanyFN();
                                                }}
                                                className="w-full px-3 py-2.5 flex items-center gap-3 text-left text-[13px] text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors"
                                            >
                                                <div className="w-6 h-6 rounded-md bg-gray-100 flex items-center justify-center flex-shrink-0">
                                                    <LuBuilding2 className="w-3.5 h-3.5 text-gray-600" />
                                                </div>
                                                <span>Risk Center</span>
                                            </button>
                                        </div>,
                                        document.body
                                    )}
                                </div>
                            )}

                            {/* Collapse toggle */}
                            <button
                                onClick={() => setSidebarCollapsedFN(!collapsed)}
                                className="p-2 hover:opacity-80 transition"
                                title="Toggle sidebar"
                            >
                                <LuPanelRight className="w-5 h-5 text-[#3b3b3b] hover:text-black" />
                            </button>
                        </div>
                    </div>
                )}




                {/* Companies + Departments + Compliance */}
                <nav className="flex flex-col mb-2 relative w-full">
                    {(() => {
                        // 1) Build company -> departments lookup
                        const depByCompany = new Map();
                        (companies || []).forEach((c) =>
                            depByCompany.set(Number(c.company_id), [])
                        );

                        const unassigned = [];

                        (departments || []).forEach((d) => {
                            if (
                                profile?.role === "User" &&
                                Number(d.department_id) !== Number(profile.department_id)
                            )
                                return;

                            const cid =
                                d.company_id === null || d.company_id === undefined
                                    ? null
                                    : Number(d.company_id);

                            if (cid === null) {
                                unassigned.push(d);
                                return;
                            }

                            if (!depByCompany.has(cid)) depByCompany.set(cid, []);
                            depByCompany.get(cid).push({ ...d, __type: "department" });
                        });

                        // 🔧 register unassigned bucket
                        depByCompany.set(
                            "unassigned",
                            unassigned.map((d) => ({ ...d, __type: "department" }))
                        );

                        // 2) Build company -> compliance lookup
                        const compByCompany = new Map();
                        (companies || []).forEach((c) =>
                            compByCompany.set(Number(c.company_id), [])
                        );

                        (complianceStandards || []).forEach((cs) => {
                            const cid =
                                cs.company_id === null ||
                                    cs.company_id === undefined ||
                                    cs.company_id === ""
                                    ? null
                                    : Number(cs.company_id);

                            if (cid === null) return;

                            if (!compByCompany.has(cid)) compByCompany.set(cid, []);
                            compByCompany.get(cid).push({ ...cs, __type: "compliance" });
                        });

                        const companyList = [...(companies || [])]
                            .filter((c) => c.hide == null)
                            .sort((a, b) =>
                                (a.title || "").localeCompare(b.title || "")
                            );



                        const renderCompanyBlock = (company) => {
                            const expanded = isCompanyExpanded(company.company_id);

                            const companyKey =
                                company.company_id === "unassigned"
                                    ? "unassigned"
                                    : Number(company.company_id);

                            const companyDepartments =
                                depByCompany.get(companyKey) || [];

                            const companyCompliance =
                                company.company_id === "unassigned"
                                    ? []
                                    : compByCompany.get(Number(company.company_id)) || [];

                            const merged = [...companyDepartments, ...companyCompliance].sort(
                                (a, b) => (a.name || "").localeCompare(b.name || "")
                            );

                            const isActiveCompany =
                                activeCompliance
                                    ? merged.some(
                                        (item) =>
                                            item.__type === "compliance" &&
                                            String(item.compliance_id) === String(activeCompliance)
                                    )
                                    : merged.some(
                                        (item) =>
                                            item.__type !== "compliance" &&
                                            String(item.department_id) === String(activeDepartmentId)
                                    );


                            const renderDepartmentRow = (department) => (
                                <div
                                    key={`dep_${department.department_id}`}
                                    className={`flex items-center justify-between cursor-pointer w-[188px] hover:bg-white hover:bg-opacity-100 hover:rounded hover:shadow-lg m-2 ml-6 ${activeDepartmentId === department.department_id && !activeCompliance
                                        ? "bg-white rounded shadow-lg"
                                        : ""
                                        }`}
                                    onMouseEnter={() => setHoveredDepartmentId(department.department_id)}
                                    onMouseLeave={() => setHoveredDepartmentId(null)}
                                >
                                    <div
                                        className="flex items-center flex-grow"
                                        onClick={() => setActiveDepartment(department.department_id)}
                                    >
                                        <button
                                            title={department.name}
                                            className="flex items-center justify-center w-7 h-7 m-2 rounded-xl ml-2"
                                            style={{ backgroundColor: department.color }}
                                        >
                                            <span className="text-white font-bold text-[9px]">
                                                {(department.name || "")
                                                    .split(" ")
                                                    .filter((w) => w.toLowerCase() !== "and")
                                                    .map((w) => w.charAt(0).toUpperCase())
                                                    .slice(0, 2)
                                                    .join("")}
                                            </span>
                                        </button>

                                        {!collapsed && (
                                            <span className="text-[12px]">
                                                {department.name?.length > 16
                                                    ? `${department.name.substring(0, 16)}...`
                                                    : department.name}
                                            </span>
                                        )}
                                    </div>

                                    {!collapsed &&
                                        ((department.department_id === activeDepartmentId ||
                                            hoveredDepartmentId === department.department_id) && !activeCompliance) && (
                                            <div className="relative">
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        const r = e.currentTarget.getBoundingClientRect();
                                                        setDeptMenuPos({ top: r.bottom + 4, left: r.right - 176 });
                                                        setDeptMenuOpenId((prev) =>
                                                            prev === department.department_id
                                                                ? null
                                                                : department.department_id
                                                        );
                                                    }}
                                                    className="absolute right-0 top-1/2 -translate-y-1/2 px-2 hover:bg-gray-100 rounded-full"
                                                >
                                                    <HiOutlineDotsVertical className="text-gray-500" />
                                                </button>

                                                {deptMenuOpenId === department.department_id && createPortal(
                                                    <div
                                                        className="fixed w-44 bg-white border border-gray-200 rounded-xl shadow-xl z-[99999] py-1 overflow-hidden"
                                                        style={{ top: deptMenuPos.top, left: deptMenuPos.left }}
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        <button
                                                            className="w-full text-left px-3 py-2.5 text-[13px] text-gray-700 hover:bg-gray-50 hover:text-gray-900 flex items-center gap-2.5 transition-colors"
                                                            onClick={() => {
                                                                setDeptMenuOpenId(null);
                                                                setMemberDepartmentId(department.department_id);
                                                                setMemberSearch("");
                                                            }}
                                                        >
                                                            <div className="w-6 h-6 rounded-md bg-gray-100 flex items-center justify-center flex-shrink-0">
                                                                <LuUserPlus className="w-3.5 h-3.5 text-gray-600" />
                                                            </div>
                                                            <span>{t("unitsSideBar.departmentMenuAddMember")}</span>
                                                        </button>

                                                        <button
                                                            className="w-full text-left px-3 py-2.5 text-[13px] text-gray-700 hover:bg-gray-50 hover:text-gray-900 flex items-center gap-2.5 transition-colors"
                                                            onClick={() => {
                                                                setDeptMenuOpenId(null);
                                                                handleManageSubRiskCenter(department.department_id);
                                                            }}
                                                        >
                                                            <div className="w-6 h-6 rounded-md bg-gray-100 flex items-center justify-center flex-shrink-0">
                                                                <LuSettings className="w-3.5 h-3.5 text-gray-600" />
                                                            </div>
                                                            <span>{t("unitsSideBar.departmentMenuManage")}</span>
                                                        </button>
                                                    </div>,
                                                    document.body
                                                )}
                                            </div>
                                        )}
                                </div>
                            );


                            const renderComplianceRow = (cs) => {
                                const isActive =
                                    Number(activeCompliance) ===
                                    Number(cs.compliance_id);

                                return (
                                    <div
                                        key={`comp_${cs.compliance_id}`}
                                        className={`flex items-center justify-between cursor-pointer w-[185px] hover:bg-white hover:bg-opacity-100 hover:rounded hover:shadow-lg m-2 ml-6 ${isActive ? "bg-white rounded shadow-lg" : ""
                                            }`}
                                        onMouseEnter={() => setHoveredComplianceId(cs.compliance_id)}
                                        onMouseLeave={() => setHoveredComplianceId(null)}
                                        onClick={() => {
                                            setActiveCompliance(cs);
                                            setCurrentDepartment(null);
                                        }}

                                    >
                                        <div className="flex items-center flex-grow">
                                            <button
                                                title={cs.name}
                                                className="flex items-center justify-center w-7 h-7 m-2 rounded-xl ml-2"
                                                style={{ backgroundColor: cs.color || "#111827" }}
                                            >
                                                <span className="text-white font-bold text-[9px]">
                                                    {(cs.name || "")
                                                        .split(" ")
                                                        .filter((w) => w.toLowerCase() !== "and")
                                                        .map((w) => w.charAt(0).toUpperCase())
                                                        .slice(0, 2)
                                                        .join("")}
                                                </span>
                                            </button>

                                            {!collapsed && (
                                                <span className="text-[12px]">
                                                    {cs.name?.length > 16
                                                        ? `${cs.name.substring(0, 16)}...`
                                                        : cs.name}
                                                </span>
                                            )}
                                        </div>

                                        {!collapsed && (
                                            <div className="flex items-center mr-2">
                                                <span className="text-[10px] text-gray-400 mr-1">
                                                    Compliance
                                                </span>

                                                {(isActive ||
                                                    hoveredComplianceId === cs.compliance_id) && (
                                                        <div className="relative">
                                                            <button
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    const r = e.currentTarget.getBoundingClientRect();
                                                                    setCompMenuPos({ top: r.bottom + 4, left: r.right - 160 });
                                                                    setCompMenuOpenId((prev) =>
                                                                        prev === cs.compliance_id
                                                                            ? null
                                                                            : cs.compliance_id
                                                                    );
                                                                }}
                                                                className="px-2 hover:bg-gray-100 rounded-full"
                                                            >
                                                                <HiOutlineDotsVertical className="text-gray-500" />
                                                            </button>

                                                            {compMenuOpenId === cs.compliance_id && createPortal(
                                                                <div
                                                                    className="fixed w-40 bg-white border border-gray-200 rounded-xl shadow-xl z-[99999] py-1 overflow-hidden"
                                                                    style={{ top: compMenuPos.top, left: compMenuPos.left }}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    <button
                                                                        className="w-full text-left px-3 py-2.5 text-[13px] text-gray-700 hover:bg-gray-50 hover:text-gray-900 flex items-center gap-2.5 transition-colors"
                                                                        onClick={() => {
                                                                            setCompMenuOpenId(null);
                                                                            setEditCompliance(cs)
                                                                            setIsCompPopupOpen(true);
                                                                        }}
                                                                    >
                                                                        <div className="w-6 h-6 rounded-md bg-gray-100 flex items-center justify-center flex-shrink-0">
                                                                            <LuPencil className="w-3.5 h-3.5 text-gray-600" />
                                                                        </div>
                                                                        <span>Edit</span>
                                                                    </button>
                                                                </div>,
                                                                document.body
                                                            )}
                                                        </div>
                                                    )}
                                            </div>
                                        )}
                                    </div>
                                );
                            };


                            return (
                                <div key={company.company_id} className="mt-2 w-full">
                                    {/* Company header */}
                                    <div
                                        className={[
                                            "mx-2 mt-2 px-2 py-2 rounded-xl flex items-center justify-between transition",
                                            isActiveCompany
                                                ? "bg-[#EEF0ED] border border-gray-300 shadow-md"
                                                : "bg-white border border-gray-200 shadow-sm",
                                        ].join(" ")}
                                    >
                                        <button
                                            type="button"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                toggleCompany(company.company_id);
                                            }}
                                            className="flex items-center gap-2 min-w-0 flex-1 text-left hover:opacity-90"
                                        >
                                            <span className="w-5 h-5 flex items-center justify-center text-gray-500">
                                                {expanded ? (
                                                    <LuChevronDown className="w-4 h-4" />
                                                ) : (
                                                    <LuChevronRight className="w-4 h-4" />
                                                )}
                                            </span>

                                            {company.icon
                                                ? <Avatar src={company.icon} name={company.title} size={18} />
                                                : <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: company.color || "#111827" }} />
                                            }

                                            <span className="text-[12px] font-semibold text-gray-800 truncate">
                                                {company.title?.length > 18
                                                    ? `${company.title.substring(0, 18)}...`
                                                    : company.title}
                                            </span>
                                        </button>

                                        {profile?.role === "Admin" && company.company_id !== "unassigned" && (
                                            <div className="relative pl-2">
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        const r = e.currentTarget.getBoundingClientRect();
                                                        setCompanyMenuPos({ top: r.bottom + 4, left: r.right - 208 });
                                                        setCompanyMenuOpenId((prev) =>
                                                            prev === company.company_id ? null : company.company_id
                                                        );
                                                    }}
                                                    className="p-1.5 rounded-md hover:bg-gray-100"
                                                >
                                                    <HiOutlineDotsVertical className="w-4 h-4 text-gray-600" />
                                                </button>

                                                {companyMenuOpenId === company.company_id && createPortal(
                                                    <div
                                                        className="fixed w-52 bg-white border border-gray-200 rounded-xl shadow-xl z-[99999] py-1 overflow-hidden"
                                                        style={{ top: companyMenuPos.top, left: companyMenuPos.left }}
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        <button
                                                            className="w-full text-left px-3 py-2.5 text-[13px] text-gray-700 hover:bg-gray-50 hover:text-gray-900 flex items-center gap-2.5 transition-colors"
                                                            onClick={() => {
                                                                setCompanyMenuOpenId(null);
                                                                createDepartmentFN({ company_id: company.company_id });
                                                            }}
                                                        >
                                                            <div className="w-6 h-6 rounded-md bg-gray-100 flex items-center justify-center flex-shrink-0">
                                                                <LuFolderPlus className="w-3.5 h-3.5 text-gray-600" />
                                                            </div>
                                                            <span>{t("unitsSideBar.companyMenuCreateSubRiskCenter")}</span>
                                                        </button>

                                                        <button
                                                            className="w-full text-left px-3 py-2.5 text-[13px] text-gray-700 hover:bg-gray-50 hover:text-gray-900 flex items-center gap-2.5 transition-colors"
                                                            onClick={() => {
                                                                setCompanyMenuOpenId(null);
                                                                setMemberCompanyId(company.company_id);
                                                                setMemberSearch("");
                                                            }}
                                                        >
                                                            <div className="w-6 h-6 rounded-md bg-gray-100 flex items-center justify-center flex-shrink-0">
                                                                <LuUserPlus className="w-3.5 h-3.5 text-gray-600" />
                                                            </div>
                                                            <span>{t("unitsSideBar.companyMenuAddMember")}</span>
                                                        </button>

                                                        <div className="h-px bg-gray-100 mx-2 my-1" />

                                                        <button
                                                            className="w-full text-left px-3 py-2.5 text-[13px] text-gray-700 hover:bg-gray-50 hover:text-gray-900 flex items-center gap-2.5 transition-colors"
                                                            onClick={() => {
                                                                handleManageRiskCenter(company.company_id);
                                                            }}
                                                        >
                                                            <div className="w-6 h-6 rounded-md bg-gray-100 flex items-center justify-center flex-shrink-0">
                                                                <LuSettings className="w-3.5 h-3.5 text-gray-600" />
                                                            </div>
                                                            <span>{t("unitsSideBar.companyMenuManageRiskCenter")}</span>
                                                        </button>
                                                    </div>,
                                                    document.body
                                                )}
                                            </div>
                                        )}

                                    </div>

                                    {/* Company items */}
                                    {expanded && (
                                        <div className="mt-1">
                                            {merged.length > 0 ? (
                                                merged.map((item) =>
                                                    item.__type === "compliance"
                                                        ? renderComplianceRow(item)
                                                        : renderDepartmentRow(item)
                                                )
                                            ) : (
                                                <div className="ml-6 mr-2 mt-2 px-3 py-2 text-[11px] text-gray-500">
                                                    No departments yet
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            );
                        };

                        return (
                            <>
                                {companyList.map((c) => renderCompanyBlock(c))}

                                {unassigned.length > 0 &&
                                    renderCompanyBlock({
                                        company_id: "unassigned",
                                        title: "Unassigned",
                                        color: "#9CA3AF",
                                    })}
                            </>
                        );
                    })()}
                </nav>




            </div>
            {(memberCompanyId || memberDepartmentId) && (
                <div
                    className="fixed inset-0 z-[100000] flex items-center justify-center bg-black/30"
                    onClick={() => {
                        setMemberCompanyId(null);
                        setMemberSearch("");
                    }}
                >
                    <div
                        className="w-full max-w-[420px] rounded-[16px] bg-white shadow-[0_20px_60px_rgba(0,0,0,0.18)] border border-[#E5E7EB] p-4"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="mb-3">
                            <div className="text-[16px] font-semibold text-[#111827]">
                                {t("riskCenterPortal.addMember.title")}
                            </div>
                            <div className="text-[13px] text-[#6B7280] mt-1">
                                {memberDepartmentId
                                    ? t("riskCenterPortal.addMember.subtitleSubRiskCenter")
                                    : t("riskCenterPortal.addMember.subtitleRiskCenter")}
                            </div>
                        </div>

                        <input
                            value={memberSearch}
                            onChange={(e) => setMemberSearch(e.target.value)}
                            placeholder={t("riskCenterPortal.addMember.searchPlaceholder")}
                            className="w-full h-[40px] rounded-[10px] border border-[#E5E7EB] px-3 text-[13px] outline-none focus:border-[#D1D5DB]"
                        />

                        <div className="mt-3 max-h-[280px] overflow-y-auto space-y-1">
                            {filteredMemberUsers.map((user) => {
                                const alreadyInCompany = user.companies?.some(
                                    (c) => Number(c.company_id) === Number(memberCompanyId)
                                );

                                const alreadyInDepartment = user.departments?.some(
                                    (d) => Number(d.department_id) === Number(memberDepartmentId)
                                );

                                const isDisabled = memberDepartmentId
                                    ? alreadyInDepartment
                                    : alreadyInCompany;

                                return (
                                    <button
                                        key={user.user_id}
                                        disabled={isDisabled}
                                        onClick={async () => {
                                            if (isDisabled) return;

                                            try {
                                                if (memberDepartmentId) {
                                                    await addUserDepartmentFN(memberDepartmentId, user.user_id);
                                                } else {
                                                    await addUserCompanyFN(memberCompanyId, user.user_id);
                                                }

                                                setMemberSuccess(t("riskCenterPortal.addMember.userAddedSuccess"));

                                                setMemberCompanyId(null);
                                                setMemberDepartmentId(null);
                                                setMemberSearch("");

                                                setTimeout(() => {
                                                    setMemberSuccess("");
                                                }, 3000);
                                            } catch (err) {
                                                console.error("Failed to add member:", err);
                                            }
                                        }}
                                        className={`w-full flex items-center gap-3 rounded-[10px] px-3 py-2 text-left transition ${isDisabled
                                                ? "bg-[#F3F4F6] cursor-not-allowed opacity-60"
                                                : "hover:bg-[#F9FAFB]"
                                            }`}
                                    >
                                        <Avatar
                                            name={`${user.first_name || ""} ${user.last_name || ""}`.trim()}
                                            src={user.avatar}
                                            size={32}
                                        />

                                        <div className="min-w-0 flex-1">
                                            <div
                                                className={`truncate text-[13px] font-medium ${isDisabled ? "text-[#9CA3AF]" : "text-[#111827]"
                                                    }`}
                                            >
                                                {`${user.first_name || ""} ${user.last_name || ""}`.trim() ||
                                                    "Unnamed User"}
                                            </div>

                                            <div
                                                className={`truncate text-[12px] ${isDisabled ? "text-[#9CA3AF]" : "text-[#6B7280]"
                                                    }`}
                                            >
                                                {user.email}
                                            </div>
                                        </div>

                                        {isDisabled && (
                                            <div className="text-[11px] text-[#9CA3AF] whitespace-nowrap">
                                                {t("riskCenterPortal.addMember.alreadyAdded")}
                                            </div>
                                        )}
                                    </button>
                                );
                            })}

                            {!filteredMemberUsers.length && (
                                <div className="px-3 py-6 text-center text-[13px] text-[#9CA3AF]">
                                    {t("riskCenterPortal.addMember.noUsersFound")}
                                </div>
                            )}
                        </div>

                        <div className="mt-4 flex justify-end">
                            <button
                                onClick={() => {
                                    setMemberCompanyId(null);
                                    setMemberDepartmentId(null);
                                    setMemberSearch("");
                                }}
                                className="h-[36px] rounded-[10px] border border-[#E5E7EB] px-4 text-[13px] text-[#374151] hover:bg-[#F9FAFB]"
                            >
                                {t("riskCenterPortal.addMember.close")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <Popup
                open={isPopupOpen}
                onClose={closeCreation}
                contentStyle={{
                    overflowY: "auto",
                    overflowX: "hidden",
                    maxHeight: "80vh",
                    width: "830px",
                    marginTop: "14vh",
                }}
            >
                <Overlay close={closeCreation} department={currentDepartment} edit={true} />
            </Popup>

            <Popup
                open={isCompanyPopupOpen}
                onClose={closeCreationCompnay}
                contentStyle={{
                    overflow: 'auto',
                    width: '520px',
                    maxHeight: '86vh',
                    height: '86vh',
                    height: "auto",
                    marginTop: '6vh',
                    padding: '0',
                    borderRadius: '12px'
                }}
            >
                <CompanyOverlay
                    close={closeCreationCompnay}
                    closeNoSave={closeCreationCompnayNoSave}
                    company_id={currentCompany?.company_id}
                    edit={true}
                />
            </Popup>


            <Popup
                open={isNotificationsPopupOpen}
                onClose={closeNotificationsPopup}
                contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '810px', marginTop: '14vh' }}
            >
                <NotificationsOverlay close={closeNotificationsPopup} department={departmentfornotifications} />
            </Popup>

            <Popup
                open={isCompPopupOpen}
                onClose={closeCompliance}
                contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '810px', marginTop: '14vh' }}
            >
                <ComplianceOverlay close={closeCompliance} compliance={editCompliance} edit={true} />
            </Popup>

            {memberSuccess && (
                <div className="fixed top-5 right-5 z-[200000] flex items-center gap-3 rounded-[8px] border border-[#E5E7EB] bg-white px-4 py-3 shadow-[0_10px_30px_rgba(0,0,0,0.12)]">
                    <div className="flex h-5 w-5 items-center justify-center rounded-full bg-[#111827] text-white text-[11px]">
                        ✓
                    </div>

                    <div className="text-[13px] font-medium text-[#111827]">
                        {memberSuccess}
                    </div>
                </div>
            )}
        </div>
    );


};


const mapStateToProps = (state) => {
    //console.log("Users ", state.admin.admin_users,)
    return {
        profile: state.profile.profile,
        sidebar_collapsed: state.auth.sidebar_collapsed,
        newlycreatedDepartmentId: state.department.newlycreatedDepartmentId,
        departments: state.department.departments,
        companies: state.department.companies,
        newlyCreatedCompanyId: state.department.newlyCreatedCompanyId,
        complianceStandards: state.compliance.complianceStandards,
        activeCompliance: state.compliance.activeComplianceId,
        users: state.admin.admin_users,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

        setSidebarCollapsedFN: (collapsed) =>
            dispatch(setSidebarCollapsed(collapsed)),
        createDepartmentFN: (options) => dispatch(createDepartment(options)),
        createCompanyFN: () => dispatch(createCompany()),
        resetNewlycreatedDepartmentIdFN: () => dispatch(resetNewlycreatedDepartmentId()),
        resetNewlycreatedCompanyIdFN: () => dispatch(resetNewlycreatedCompanyId()),
        getDepartmentsFN: () => dispatch(getDepartments()),
        updateDepartmentFN: (department_id, data) => dispatch(updateDepartment(department_id, data)),
        getCompaniesFN: () => dispatch(getCompanies()),
        updateCompanyFN: (company_id, data) => dispatch(updateCompany(company_id, data)),
        getComplianceStandardsByCompanyFN: () => dispatch(getComplianceStandardsByCompany()),
        deleteDepartmentFN: (id) => dispatch(deleteDepartment(id)),
        deleteStandartFN: (compliance_id) => dispatch(deleteComplianceStandard(compliance_id)),
        deleteCompanyFN: (id) => dispatch(deleteCompany(id)),
        addUserDepartmentFN: (department, user) => dispatch(addUserDepartment(department, user)),
        addUserCompanyFN: (company, user) => dispatch(addUserCompany(company, user))

    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
    UnitsSideBar
);